import { createApp } from 'vue';
import App from './App.vue';

import Moment from 'moment/moment';

import axios from 'axios'
import VueAxios from 'vue-axios';

VueAxios.prototype.$http = axios;
axios.defaults.baseURL = 'http://localhost:8080';
//axios.defaults.baseURL = 'http://localhost/Beispiele/Vue.js/start/eins/dist/';
//axios.defaults.baseURL = 'https://www.webdesign-sturm.de/kunden/kultur-mittelsachsen/kalender/';
//axios.defaults.baseURL = 'https://www.webdesign-sturm.de/kunden/kultur-mittelsachsen/advent/';
//axios.defaults.baseURL = 'https://www.kultur-mittelsachsen.de/wp-content/themes/kultur-mittelsachsen/';
//axios.defaults.baseURL = 'http://localhost/kultur-mittelsachsen.de/wordpress_localhost/wp-content/themes/kultur-mittelsachsen/';

const app = createApp(App);

app.use(Moment);
app.use(VueAxios,axios);

app.mount('#app');